<template>
  <header class="sticky top-0 z-40 border-b border-white/10 bg-slate-950/80 backdrop-blur-xl">
    <div class="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <router-link to="/" class="flex items-center gap-3">
        <div class="rounded-2xl bg-cyan-500/15 p-2 ring-1 ring-cyan-300/20">
          <CloudIcon class="h-6 w-6 text-cyan-300" />
        </div>
        <div>
          <div class="font-display text-lg font-bold text-white">{{ i18n.t('common.brand') }}</div>
          <div class="text-xs text-slate-400">{{ i18n.t('common.brandTag') }}</div>
        </div>
      </router-link>

      <nav class="hidden items-center gap-6 md:flex">
        <router-link
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          class="text-sm text-slate-300 transition hover:text-white"
          :class="route.path === item.to ? 'text-white' : ''"
        >
          {{ item.label }}
        </router-link>
      </nav>

      <div class="flex items-center gap-3">
        <LanguageSwitch />

        <router-link
          to="/member"
          class="hidden rounded-full border border-cyan-300/30 px-4 py-2 text-sm font-medium text-cyan-100 transition hover:bg-cyan-400/10 md:inline-flex"
        >
          {{ memberStore.isAuthenticated ? memberStore.currentMember?.email : i18n.t('nav.member') }}
        </router-link>

        <router-link
          to="/console"
          class="inline-flex rounded-full bg-cyan-400 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-cyan-300"
        >
          {{ i18n.t('nav.console') }}
        </router-link>

        <button
          v-if="memberStore.isAuthenticated"
          type="button"
          class="hidden text-sm text-slate-400 transition hover:text-white md:inline-flex"
          @click="memberStore.logout()"
        >
          {{ i18n.t('common.logout') }}
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { CloudIcon } from '@heroicons/vue/24/outline';
import LanguageSwitch from '../common/LanguageSwitch.vue';
import { useI18nStore } from '../../stores/i18n';
import { useMemberStore } from '../../stores/member';

const route = useRoute();
const i18n = useI18nStore();
const memberStore = useMemberStore();

const navItems = computed(() => [
  { to: '/', label: i18n.t('nav.home') },
  { to: '/pricing', label: i18n.t('nav.pricing') },
  { to: '/docs', label: i18n.t('nav.docs') },
  { to: '/geo', label: i18n.t('nav.geo') },
  { to: '/member', label: i18n.t('nav.member') },
]);
</script>
